/**
 * @fileoverview Slice Redux para gerenciamento do modal de sincronização Hiper.
 * Controla estado de abertura/fechamento do HiperSyncProducts.
 *
 * @module HiperSyncSlice
 * @since 1.0.0
 */

import { createSlice } from '@reduxjs/toolkit';

const hiperSyncSlice = createSlice({
  name: 'hiperSync',
  initialState: {
    isOpen: false,
  },
  reducers: {
    /**
     * Abre o modal de sincronização Hiper.
     */
    openHiperSync: (state) => {
      state.isOpen = true;
    },
    /**
     * Fecha o modal de sincronização Hiper.
     */
    closeHiperSync: (state) => {
      state.isOpen = false;
    },
  },
});
 
export const { openHiperSync, closeHiperSync } = hiperSyncSlice.actions;
export default hiperSyncSlice.reducer;
